package com.essntl.features.service.ui.addextraservice

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.service.domain.model.extraservice.ExtraServiceModel
import com.essntl.features.service.domain.model.service.ServiceFilterOptions
import com.essntl.features.service.domain.model.service.ServiceModel

data class AddExtraServiceState(
    // Extra service
    val extraService: MutableState<ExtraServiceModel> = mutableStateOf(ExtraServiceModel.empty),
    val addExtraService: State<ExtraServiceModel> = State(),

    // Service
    val getAllExtraCategoryService: PaginationState<ServiceModel> = PaginationState(),
    val service: ServiceModel = ServiceModel.empty,
    val addService: State<ServiceModel> = State(),
    val filterOptions: ServiceFilterOptions = ServiceFilterOptions(),
)
